import { getClient } from "@lg-cfa/services";
import { AxiosInstance } from "axios";

import { MakeDto } from "@types";

/**
 * Service class for managing car Lead related operations.
 */
class CarService {
    /**
     * HTTP client instance for making requests.
     */
    public client: AxiosInstance;

    /**
     * Base path for jump-related API endpoints.
     */
    private basePath = "vehicle";

    constructor() {
        this.client = getClient();
    }

    /**
     * Constructs the full API endpoint path.
     * @param path - The specific endpoint path to append to the base path.
     * @returns The full API endpoint path.
     */
    private getFullPath(path = ""): string {
        return `${this.basePath}${path}`;
    }

    public getAllMakes() {
        return this.client
            .get<MakeDto[]>(this.getFullPath("/makes"))
            .then((res) => res.data);
    }

    public getDetailsOfModel(make: string, model: string) {
        return this.client
            .get<MakeDto>(this.getFullPath("/makes/models"), {
                params: { make, model },
            })
            .then((res) => res.data);
    }
}

export const carService = new CarService();
